export class OriginConfig {
    originCode: string;
    partitioningCode: string;
    year: number;
    amountStageCode: string;

    constructor(origin: { code?: string, partitioningCode?: string, year?: number, amountStageCode?: string }) {
        this.originCode = origin.code || null;
        this.partitioningCode = origin.partitioningCode || null;
        this.year = origin.year || null;
        this.amountStageCode = origin.amountStageCode || null;
    }
}
